export default __webpack_public_path__ + "static/media/home-1.9f67aae1.jpg";